import { render, staticRenderFns } from "./rowCol.vue?vue&type=template&id=6ebfe828"
import script from "./rowCol.vue?vue&type=script&lang=js"
export * from "./rowCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports